// =======================
// == Animations/Donut.js ==
// =======================
/*
  All of the animations for donut.js
*/

import Animator from './animator';

const animate = percentage => {
  new Animator().call(`.donut-${percentage} circle:last-of-type`, {
    strokeDasharray: [
      { value: `0 100`, duration: 0 },
      { value: `${percentage} ${100 - percentage}`, duration: 750 },
    ],
    easing: 'easeInQuad',
  });
};

export default animate;
